import { Component, Input, Output, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { JarwisService } from '../../Services/jarwis.service';
import { MAT_CHECKBOX_CLICK_ACTION } from '@angular/material';
import { DataApiService } from '../../Services/data-api.service';



import * as moment from 'moment';
import { AlertRefreshComponent } from '../dialogs/alert-refresh/alert-refresh.component';
import { AlertComponent } from '../dialogs/alert/alert.component';



@Component({
  selector: 'app-resume',
  templateUrl: './resume.component.html',
  styleUrls: ['./resume.component.scss']
})
export class ResumeComponent {
  @Input() form: any;
  @Output() regresar = new EventEmitter<any>();

  constructor(
    private dataApi: DataApiService,
    private Jarwis: JarwisService,
    private dialog: MatDialog,
  ) {
  }

  public formFinalizar = {
    data: null,
    modoPago: null
  }


  esperandoProceso: boolean = false;
  mensaje = "El pedido se ha realizado correctamente.";

  formatDate(date: any): string {
    return moment(date).format("YYYY-MM-DD");
  }
  conversionFecha(e) {
    const date = new Date(e);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }


  procesar() {

    this.esperandoProceso = true;
    document.querySelector(".procesar").setAttribute("disabled", "true");

    this.Jarwis.nuevoPedido(this.formFinalizar).subscribe((data) => {
      const dialogRef = this.dialog.open(AlertRefreshComponent, {
        width: "400px",
        panelClass: "alert-dialog-container",
        data: { mensaje: "El pedido se ha realizado correctamente" },
        disableClose: true,
        autoFocus: true
      });
    })
  }

  eliminarNull(info: any) {

    const infoPedidoLimpio = info.filter(item =>
      Object.values(item).some(valor => valor !== null)
    );
    return infoPedidoLimpio;

  }



  onRegresar(): void {
    this.regresar.emit();
  }

  cancelar() {
    this.regresar.emit();
  }

  ngOnInit() {
    this.formFinalizar.data = this.form;


  }

}
